import { useState } from "react";
import { useNavigate } from "react-router";
import { Link, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { SubmitButton } from "../../components/auth/SubmitButton";
import "../../styles/AuthPages.css";
import handleAxiosError from "../../components/ErrorHandler";
import { notifErr, notifOk } from "../../components/Functions";
import { postFetcher } from "../../components/Fetchers";

const LoginPage = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await postFetcher(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        credentials
      );

      setCredentials({ email: "", password: "" });
      notifOk(response.data);
      navigate("/quick-search");
    } catch (err) {
      notifErr(handleAxiosError(err));
    } finally {
      setCredentials({ ...credentials, password: "" });
    }
  };

  return (
    <div className="authContainer">
      <div className="square left"></div>
      <div className="square right"></div>
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          flexDirection: "column",
        }}
      >
        <Typography variant="h5" align="center" fontWeight="bold" mb="0.5rem">
          Přihlášení
        </Typography>

        <TextField
          id="email"
          placeholder="email"
          variant="outlined"
          value={credentials.email}
          onChange={(e) =>
            setCredentials({ ...credentials, email: e.target.value })
          }
          size="small"
          sx={{ mt: "0.5rem" }}
        />

        <TextField
          id="password"
          type="password"
          placeholder="password"
          variant="outlined"
          value={credentials.password}
          onChange={(e) =>
            setCredentials({ ...credentials, password: e.target.value })
          }
          size="small"
          sx={{ mt: "0.5rem" }}
        />

        <SubmitButton label={"Přihlásit"} />

        <Link
          href="/signup"
          variant="body2"
          underline="hover"
          sx={{ mt: "1rem" }}
        >
          Vytvořit nový účet
        </Link>
      </Box>
    </div>
  );
};

export default LoginPage;
